export default function ISFP(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “ماجراجو”</h1>{" "}
          <blockquote>
            <p>
              من در طول روز عوض می&zwnj;شوم. وقتی از خواب بیدار می&zwnj;شوم یک
              شخص هستم و وقتی می&zwnj;خواهم بخوابم مطمئنم که شخص دیگری
              شده&zwnj;ام.
            </p>{" "}
            <footer>Bob Dylan</footer>
          </blockquote>{" "}
          <p>
            شخصیت ماجراجو هنرمندانی واقعی هستند، اما نه لزوماً به معنای متداول
            کلمه و اینکه در فضای باز به نقاشی درختانی کوچک مشغول باشند. اگرچه
            خیلی اوقات به&zwnj;خوبی می&zwnj;توانند چنین کاری را هم انجام بدهند.
            بلکه مسئله این است که آنها از زیبایی&zwnj;شناسی، طراحی و حتی
            انتخاب&zwnj;ها و اعمال خود برای فشار وارد کردن به محدودیت&zwnj;های
            قراردادهای اجتماعی بهره می&zwnj;گیرند. شخصیت&zwnj;های ماجراجو از پشت
            کردن به انتظارات سنتی با انجام آزمایش&zwnj;هایی در زمینه زیبایی و
            رفتار لذت می&zwnj;برند - احتمالاً بارها و بارها این عبارت را
            گفته&zwnj;اند که "مرا در قفس نینداز!"
          </p>{" "}
          <h2>از آنچه که هستند خرسندند</h2>{" "}
          <p>
            افراد ماجراجو در دنیایی نفسانی و رنگارنگ زندگی می&zwnj;کنند که از
            ارتباطات با افراد و ایده&zwnj;ها الهام گرفته باشد. شخصیت&zwnj;های
            ماجراجو از بازتفسیر این ارتباطات، ابداع دوباره و آزمودن خودشان و
            دیدگاه&zwnj;های جدید لذت می&zwnj;برند. هیچ نوع شخصیتی دیگری بیش از
            آنها به کنکاش و آزمایش به این طریق دست نمی&zwnj;زند. این امر حس
            خودانگیختگی را ایجاد می&zwnj;کند و باعث می&zwnj;شود افراد ماجراجو
            حتی برای دوستان نزدیک و عزیزان خود هم غیرقابل پیش&zwnj;بینی به نظر
            برسند.
          </p>{" "}
          <p>
            با این همه، افراد ماجراجو قطعاً درونگرا هستند، و وقتی از کانون توجه
            خارج می&zwnj;شوند تا تنها باشند و دوباره نیرو بگیرند باعث غافلگیر
            شدن بیشتر دوستان خود می&zwnj;گردند. هرچند تنها شدن افراد با نوع
            شخصیتی ماجراجو به این معنی نیست که بیکار می&zwnj;نشینند - آن&zwnj;ها
            از این زمان برای درون&zwnj;نگری، ارزیابی و بازارزیابی اصول خود بهره
            می&zwnj;گیرند. افراد ماجراجو بجای اینکه در گذشته یا آینده متوقف
            شوند، در مورد اینکه چه کسی هستند فکر می&zwnj;کنند. وقتی از غار
            تنهایی خود برمی&zwnj;گردند، متحول شده&zwnj;اند.
          </p>{" "}
          <p>
            افراد ماجراجو در زندگی به دنبال پیدا کردن راه&zwnj;هایی برای پیشبرد
            اشتیاق خود هستند. رفتارهای پرمخاطره مانند قماربازی و ورزش&zwnj;های
            خطرناک در بین این نوع شخصیتی شایع&zwnj;تر است. خوشبختانه
            هم&zwnj;سویی آنها با لحظه و محیط به آنها این امکان را می&zwnj;دهد تا
            نسبت به سایرین عملکرد بهتری داشته باشند. افراد ماجراجو همچنین از
            برقراری ارتباط با دیگران لذت می&zwnj;برند و جذابیتی دارند که
            نمی&zwnj;توان در برابر آن مقاومت کرد.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              افراد ماجراجو همیشه می&zwnj;دانند که با تعریف و تمجید
              می&zwnj;توانند دل&zwnj;های افرادی که سعی می&zwnj;کنند اعمال
              مخاطره&zwnj;آمیز آنها را غیرمسئولانه یا بی&zwnj;پروایانه بدانند،
              نرم کنند.
            </p>
          </blockquote>{" "}
          <p>
            با این حال، اگر انتقادی مطرح شود، ممکن است سرانجام خوشی نداشته باشد.
            برخی افراد ماجراجو می&zwnj;توانند نظراتی که با تعابیر دوستانه مطرح
            شده باشد را تحمل کنند، و برای آنها به&zwnj;عنوان دیدگاه دیگری برای
            کمک به پیشبرد اشتیاق خود در راه&zwnj;های تازه ارزش قائل شوند. اما
            اگر اظهار نظر گزنده&zwnj;تر بوده و چندان پخته نباشد، ممکن است
            شخصیت&zwnj;های ماجراجو به شکلی جالب اختیار خود را از کف بدهند.
          </p>{" "}
          <p>
            افراد ماجراجو نسبت به احساسات دیگران حساس بوده و برای هماهنگی ارزش
            قائل هستند. وقتی افراد دارای این نوع شخصیت با انتقاد مواجه
            می&zwnj;شوند ممکن است نتوانند به&zwnj;راحتی خود را به قدر کفایت کنار
            بکشند تا گرفتار بحث&zwnj;های داغ نشوند. اما زندگی در لحظه در هر دو
            سمت جریان پیدا می&zwnj;کند و وقتی احساسات شدید بحث و جدل فروکش کرد،
            افراد ماجراجو معمولاً می&zwnj;توانند گذشته را متعلق به گذشته بدانند
            و طوری به حرکت خود ادامه بدهند که انگار هرگز رخ داده است.
          </p>{" "}
          <h2>معنا در هر بیان زندگی نهفته است</h2>{" "}
          <p>
            بزرگ&zwnj;ترین چالش برای افراد ماجراجو برنامه&zwnj;ریزی برای آینده
            است. پیدا کردن آرمان&zwnj;هایی سازنده برای پایه&zwnj;گذاری اهداف خود
            و تلاش برای رسیدن به اهداف که اصول مثبتی پدید می&zwnj;آورد به هیچ
            وجه کار کوچکی نیست. افراد ماجراجو بر خلاف برخی از انواع شخصیتی دیگر،
            برای آینده خود از نظر دارایی و بازنشستگی برنامه&zwnj;ریزی
            نمی&zwnj;کنند. بلکه اقدامات و رفتارهای خود را به&zwnj;عنوان کارهایی
            که به حس هویتشان یاری می&zwnj;رساند برنامه&zwnj;ریزی می&zwnj;کنند،
            یعنی موجب ایجاد سبدی از تجربیات می&zwnj;شود، نه سبد سهام.
          </p>{" "}
          <p>
            اگر این اهداف و اصول شرافت&zwnj;مندانه باشند، ممکن است افراد ماجراجو
            اعمالی توأم با بخشش و از خود گذشتگی شگفت&zwnj;انگیز انجام دهند - اما
            این احتمال هم وجود دارد که افراد دارای سنخ شخصیتی ماجراجو هویتی
            خودمحورانه برای خود دست و پا کنند و براساس خودخواهی، تقلب و خودپرستی
            دست به عمل بزنند. برای افراد ماجراجو مهم است به یاد داشته باشند که
            برای تبدیل شدن به شخصی که می&zwnj;خواهند باشند باید فعال باشند. ممکن
            است پدید آوردن و حفظ یک عادت جدید به&zwnj;طور طبیعی رخ ندهد، اما
            افراد دارای شخصیت ماجراجو با صرف وقت در هر روز برای درک
            انگیزه&zwnj;های خود می&zwnj;توانند از نقاط قوت خود استفاده کرده و هر
            آنچه که عاشق آن شده&zwnj;اند را دنبال کنند.
          </p>
        </article>
      </div>
    </div>
  );
}
